import { useMxfNestToast } from "hooks";

export const useRelCatIbs = () => {
  const { onSend, isLoading } = useMxfNestToast();

  const onCreate = async data => {
    return onSend({
      endpoint: "rel-ibscbs-cat/bulk",
      data,
      type: "POST",
      redirect: false,
    });
  };
  return { onCreate, isLoading };
};
